import { useState, useCallback } from 'react';

export function useVariantsModal() {
    const [open, setOpen] = useState(false);
    const [productId, setProductId] = useState(null);

    const openModal = useCallback((programId, productId) => {
        setProductId(productId);
        setOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setOpen(false);
        setProductId(null);
    }, []);

    return {
        open,
        productId,
        openModal,
        closeModal,
    };
}
